import Moment from 'moment';
import { Task, SharePermission } from "../interfaces/Task";
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { handleApiError, safeJsonParse } from "../../utils/api";

interface TaskItemProps {
    task: any;
    duplicateCallback: CallableFunction;
    deleteCallback: CallableFunction;
}

export default function TaskItemShared(props: TaskItemProps) {
    const { t } = useTranslation();

    const userId = localStorage.getItem('userId') ?? '';

    const navigate = useNavigate();
    const [owner, setOwner] = useState('Unknown name');
    const [canEdit, setCanEdit] = useState(false);

    const handleEditTask = () => {
        navigate('/edit-task/' + props.task._id);
    }

    const handleDuplicateTask = () => {
        fetch(import.meta.env.VITE_API_URL + '/v1/task/' + props.task._id,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            })
            .then(response => {
                if (handleApiError(response, navigate)) {
                    return null;
                }
                return safeJsonParse(response);
            })
            .then(data => {
                if (!data) return;
                const newTask: Task = data;
                newTask._id = '';
                newTask.name = props.task.name + ' ' + t("(copy)");
                newTask.userId = localStorage.getItem('userId') ?? '';
                newTask.clonned = true;
                newTask.original_source = 'shared';
                newTask.original_task = props.task._id;

                const requestOptionsPost = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    },
                    body: JSON.stringify(newTask)
                };
                fetch(import.meta.env.VITE_API_URL + '/v1/task', requestOptionsPost)
                    .then(response => {
                        if (handleApiError(response, navigate)) {
                            return null;
                        }
                        return safeJsonParse(response);
                    })
                    .then(data => {
                        if (!data) return;
                        props.duplicateCallback(data);
                    });
            });
    }

    const handleDiscardTask = () => {
        fetch(import.meta.env.VITE_API_URL + '/v1/task-shares/unshare-one',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify({
                    task: props.task._id,
                    user: userId
                })
            })
            .then(response => {
                return safeJsonParse(response);
            })
            .then(data => {
                props.deleteCallback(props.task._id);
            });
    }

    useEffect(() => {
        // Check if the task has edit permission
        if (props.task.permission === 'edit' || props.task.canEdit) {
            setCanEdit(true);
        }
    }, [props.task]);

    return(
        <div className={`task-item teaser ${canEdit ? 'can-edit' : ''}`} key={ 'task-' + props.task._id }>
            <div className="title">
                { props.task.name }
                { canEdit &&
                    <span className="permission-badge edit-badge" title={t("You can edit this task")}>
                        {t("Can edit")}
                    </span>
                }
            </div>
            <div className="meta">
                <div className="changed">
                    <div className="updated">
                        { t("Last updated") }: <span>{ Moment(props.task.updated).format('DD/MM/YYYY') }</span>
                    </div>
                    { props.task.group === undefined &&
                        <div className="owner">
                            { t("Shared by user") }: <span>{ props.task.userFullName }</span>
                        </div>
                    }
                    { props.task.group !== undefined &&
                        <div className="owner">
                            { t("Shared by group") }: <span>{ props.task.group }</span>
                        </div>
                    }
                </div>
                <div className="actions">
                    { canEdit &&
                        <button className="no-decoration edit" title={ t("Edit") } onClick={ handleEditTask }></button>
                    }
                    <button className="no-decoration duplicate" title={ t("Duplicate") } onClick={ handleDuplicateTask }></button>
                    <button className="no-decoration delete" title={ t("Discard") } onClick={ handleDiscardTask }></button>
                </div>
            </div>
        </div>
    );
}